import css from './FormComment.module.css';

function FormComment({ children }) {
    return <div>{children.map((x) => x)}</div>;
}

export default FormComment;
